import catalog from './translations.json'
import { languages } from '../i18n'
const tables=catalog as Record<string,Record<string,string>>
export function ct(language:string,text:string,values:Record<string,string|number>={}){
  const translated=tables[language]?.[text]??text
  return translated.replace(/\{(\w+)\}/g,(token,key)=>values[key]===undefined?token:String(values[key]))
}
export const languageName=(locale:string)=>languages.find(([code])=>code===locale)?.[1]??locale
export function challengeEvent(language:string,text:string){
  const tr=(key:string,values:Record<string,string|number>={})=>ct(language,key,values)
  const num=(value:string)=>Number(value.replaceAll(',','')).toLocaleString(language)
  let m=text.match(/^(.+) rolled (\d) \+ (\d), earned ([\d,]+) coins, and upgraded (.+) to level (\d)\.$/)
  if(m)return tr('{name} rolled {dice}, earned {coins} coins, and upgraded {landmark} to level {level}.',{name:m[1],dice:`${m[2]} + ${m[3]}`,coins:num(m[4]),landmark:tr(m[5]),level:m[6]})
  m=text.match(/^(.+) rolled (\d) \+ (\d), earned ([\d,]+) coins, and saved for a future upgrade\.$/)
  if(m)return tr('{name} rolled {dice}, earned {coins} coins, and saved for a future upgrade.',{name:m[1],dice:`${m[2]} + ${m[3]}`,coins:num(m[4])})
  m=text.match(/^You rolled (\d) \+ (\d) and earned ([\d,]+) challenge coins\.$/)
  if(m)return tr('You rolled {dice} and earned {coins} challenge coins.',{dice:`${m[1]} + ${m[2]}`,coins:num(m[3])})
  m=text.match(/^You upgraded (.+) to level (\d)\.$/)
  if(m)return tr('You upgraded {landmark} to level {level}.',{landmark:tr(m[1]),level:m[2]})
  m=text.match(/^Game restarted\. Everyone keeps (\d+) remaining challenge turns; no rolls were added\.$/)
  if(m)return tr('Game restarted. Everyone keeps {count} remaining challenge turns; no rolls were added.',{count:m[1]})
  return tr(text)
}
